import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import { BiX } from "react-icons/bi";

const Index = (props) => (
  <div key={props.key} className={`tag-wrapper ${props.type}`}>
    <div className={"rd-text"}>{props.text}</div>
  </div>
);

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
